<template>
  <view-wrapper
    prefix="Edit"
    name="Counter"
    path="counters"
    :showCancel="true"
    saveText="Save"
    :saveFunc="save"
    :hasChangesBeenMade="hasChangesBeenMade"
    :validation="validation"
    :loading="loading"
  >
    <wrapper :checkForChildFocused="true" class="p-5 pt-10 mb-3" :focus="name !== ''">
      <grafokett-input
        class="w-96"
        v-model="name"
        :editable="true"
        labelPlaceholder="Name (required)"
      />
    </wrapper>

    <wrapper :checkForChildFocused="true" class="p-5 mb-3">
      <grafokett-input
        class="w-96"
        v-model="description"
        :editable="true"
        labelPlaceholder="Description (optional)"
      />
    </wrapper>

    <wrapper :checkForChildFocused="true" class="p-5 mb-3">
      <grafokett-input
        class="w-96"
        type="number"
        v-model="startValue"
        :editable="true"
        labelPlaceholder="Start value"
      />
    </wrapper>

    <wrapper :checkForChildFocused="true" class="p-5 mb-3">
      <grafokett-input
        class="w-96"
        type="number"
        v-model="currentValue"
        :editable="true"
        labelPlaceholder="Current value"
      />
    </wrapper>

    <wrapper :checkForChildFocused="true" class="p-5 mb-3">
      <grafokett-input
        class="w-96"
        type="number"
        v-model="stepValue"
        :editable="true"
        labelPlaceholder="Step value"
      />
    </wrapper>

    <wrapper :checkForChildFocused="true" class="p-5 mb-3">
      <grafokett-input
        class="w-96"
        type="number"
        v-model="zeroPadLength"
        :editable="true"
        labelPlaceholder="Zero-pad length (optional)"
      />
    </wrapper>

    <modal
      v-if="error"
      @close="error = false"
      type="error"
      heading="Error"
      :description="errorText"
    />
  </view-wrapper>
</template>

<script>
import GrafokettInput from "../components/forms/Input.vue";
import Modal from "../components/Modal";

export default {
  components: {
    GrafokettInput,
    Modal,
  },
  data() {
    return {
      name: "",
      description: "",
      startValue: 0,
      currentValue: 0,
      stepValue: 1,
      zeroPadLength: null,
      original: null,
      loading: false,
      error: false,
      errorText: "",
    };
  },
  methods: {
    parseOptionalInt(value, fallback = null) {
      if (value === null || value === undefined || value === "") return fallback;
      const parsed = parseInt(value, 10);
      return Number.isNaN(parsed) ? fallback : parsed;
    },
    validation() {
      return this.name !== "" && this.name != null;
    },
    hasChangesBeenMade() {
      if (!this.original) return false;
      return (
        this.name !== this.original.name ||
        this.description !== this.original.description ||
        String(this.startValue) !== String(this.original.startValue) ||
        String(this.currentValue) !== String(this.original.currentValue) ||
        String(this.stepValue) !== String(this.original.stepValue) ||
        String(this.zeroPadLength) !== String(this.original.zeroPadLength)
      );
    },
    async save() {
      this.loading = true;
      try {
        await this.$store.dispatch("COUNTERS/UPDATE_COUNTER", {
          id: this.$route.params.id,
          name: this.name,
          description: this.description || null,
          startValue: this.parseOptionalInt(this.startValue, 0),
          currentValue: this.parseOptionalInt(this.currentValue, 0),
          stepValue: this.parseOptionalInt(this.stepValue, 1),
          zeroPaddedLength: this.parseOptionalInt(this.zeroPadLength, null),
        });
        this.$router.push("/counters");
      } catch (e) {
        this.error = true;
        this.errorText =
          (e && e.response && e.response.data && e.response.data.Message) ||
          "Could not save counter";
      } finally {
        this.loading = false;
      }
    },
  },
  async mounted() {
    this.loading = true;
    try {
      const counter = await this.$store.dispatch(
        "COUNTERS/GET_COUNTER",
        this.$route.params.id
      );
      this.name = counter.name || "";
      this.description = counter.description || "";
      this.startValue = counter.startValue != null ? counter.startValue : 0;
      this.currentValue = counter.currentValue != null ? counter.currentValue : 0;
      this.stepValue = counter.stepValue != null ? counter.stepValue : 1;
      this.zeroPadLength =
        counter.zeroPaddedLength != null
          ? counter.zeroPaddedLength
          : counter.zeroPadLength != null
            ? counter.zeroPadLength
            : null;
      this.original = {
        ...counter,
        zeroPadLength:
          counter.zeroPaddedLength != null
            ? counter.zeroPaddedLength
            : counter.zeroPadLength != null
              ? counter.zeroPadLength
              : null,
      };
    } catch (e) {
      this.error = true;
      this.errorText = "Could not load counter";
    } finally {
      this.loading = false;
    }
  },
};
</script>
